/* unplugin-vue-components disabled */import script from "./manage-notification.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-notification.vue?vue&type=script&lang=ts&setup=true"

import "./manage-notification.vue?vue&type=style&index=0&id=0a33a44d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a33a44d"]])

export default __exports__